import React from "react";
import { makeStyles, Spinner, tokens } from "@fluentui/react-components";

interface LoadingSpinnerProps {
  message?: string;
}

const useStyles = makeStyles({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    opacity: 0.4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "1rem",
    zIndex: 9999,
  },
});

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Loading...",
}) => {
  const styles = useStyles();

  return (
    <div className={styles.overlay}>
      <Spinner size="large" label={message} />
    </div>
  );
};

export default LoadingSpinner;
